import { Component, Input } from '@angular/core';

@Component({
  selector: 'craft-text-toolbar',
  templateUrl: './text-toolbar.component.html',
  styleUrls: ['./text-toolbar.component.scss'],
  standalone: false,
  host: {
    '[class.static]': 'state && position === "static"',
  },
})
export class TextToolbarComponent {
  @Input() public left = 0;
  @Input() public top = 0;
  @Input() public state = false;
  @Input() public position: 'fixed' | 'static' = 'fixed';

  constructor() {}

  public applyChange(type: string, valueArgument?: string) {
    document.execCommand(type, false, valueArgument);
  }
}
